import React, { useCallback, useMemo } from "react";
import { SelectUBOType } from "../../selectors/uboType/selectUBOType";
import { PrivateIndividualForm } from "../ubo-forms/privateIndividualForm";
import { PrivateCompanyForm } from "../ubo-forms/privateCompanyForm";
import { PartnershipForm } from "../ubo-forms/partnershipForm";
import { StockExchangeForm } from "../ubo-forms/stockExchangeForm";
import { RegulatedEntityForm } from "../ubo-forms/regulatedEntityForm";
import { PensionFundForm } from "../ubo-forms/pensionFundForm";
import { CharitiesForm } from "../ubo-forms/charitiesForm";
import { SovereignWealthFundsForm } from "../ubo-forms/sovereignWealthFundsForm";
import { PublicSectorForm } from "../ubo-forms/publicSectorForm";
import { FundForm } from "../ubo-forms/fundForm";
import { FoundationsForm } from "../ubo-forms/foundationsForm";
import { UnitTrustForm } from "../ubo-forms/unitTrustForm";
import { TrustForm } from "../ubo-forms/trustForm";
import { ChurchBodiesForm } from "../ubo-forms/chruchBodies";
import { Input } from "../../ui/Input";


export const UBOForm = React.memo(({renderBy, index, uboType, uboPercentage, uboData, onUBOChange, label = undefined, name = undefined, required = undefined, isReadOnly, isReport}) => {
    isReadOnly = isReadOnly || false;
    const handleTypeChange = useCallback((newType) => {
        onUBOChange({
            type: 'CHANGE_TYPE',
            payload: newType
        });
    }, [onUBOChange]);

    const handlePercentageChange = useCallback((newPercentage) => {
        onUBOChange({
            type: 'CHANGE_PERCENTAGE',
            payload: newPercentage
        });
    }, [onUBOChange]);

    const handleFieldChange = useCallback((e) => {
      console.log("Field Change", e.target.name, e.target.value);
        onUBOChange({
            type: 'UPDATE_FIELD',
            payload: { 
                field: e.target.name,
                value: e.target.value 
              }
        })
    }, [onUBOChange]);

    const renderFields = useCallback((uboType, uboData) => {
    
            switch (uboType) {
              case "Private Individual (Natural Person)":
                return (
                  <PrivateIndividualForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
              case "Private Company":
                return (
                  <PrivateCompanyForm
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
        
        
              case "Partnership":
                return (
                  <PartnershipForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
        
        
              case "Company Listed on a Recognised Stock Exchange":
                return (
                  <StockExchangeForm
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
        
        
              case "Regulated Entity":
                return (
                  <RegulatedEntityForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
              case "Pension Fund":
                return (
                  <PensionFundForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
              // [x] Charities
              case "Charities":
                return (
                  <CharitiesForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
              // [x] Sovereign Wealth Funds 
              case "Sovereign Wealth Funds":
                return (
                  <SovereignWealthFundsForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
              // [x] Public Sector Bodies, governments, state owned companies and local authorities. 
              case "Public Sector Bodies, governments, state owned companies and local authorities.":
                return (
                  <PublicSectorForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
              // [x] Fund
              case "Fund":
                return (
                  <FundForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
              
                // [x] Foundations
              case "Foundations":
                return (
                  <FoundationsForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
              
              // [x] Unit Trust
              case "Unit Trust":
                return (
                  <UnitTrustForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
              
              // [x] Trust Form
              case "Trust":
                return (
                  <TrustForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
        
        
              // [x] Chruch Bodies
              case "Church bodies":
                return (
                  <ChurchBodiesForm 
                    renderBy={renderBy}
                    isReport={isReport}
                    index={index}
                    isReadOnly={isReadOnly}
                    formData={uboData}
                    onChange={handleFieldChange}
                  />
                );
        
              default:
                return null;
        
            }
          }, [handleFieldChange, index, isReadOnly, renderBy]);

    
    return (
        <>
            {
              renderBy === "corporate" && (
                <Input 
                label="UBO Percentage"
                isReport={isReport}
                type="text"
                name="uboPercentage"
                value={uboPercentage}
                onChange={(e)=> handlePercentageChange(e.target.value)}
                disabled={isReadOnly}
                required={required}
              />  
              )
            }
            <SelectUBOType
                renderBy={renderBy}
                isReport={isReport}
                index={index}
                disabled={isReadOnly}
                label={label}
                name={name}
                required={required}
                value={uboType}
                onChange={handleTypeChange}
            />
            {renderFields(uboType, uboData)}
        </>
    );
});